export default "__VITE_ASSET__e8c1b1d0__"